import React from "react";

import { StoryCard } from "../basic/story-card.js"
import { MediaObjectsList } from "../basic/media-object-list.js"
import { SectionName } from "../basic/section-name.js";
import { DfpAd } from "../dfp-ad";

import { wrapCollectionLayout } from "@quintype/components";
import {collectionColor, collectionSection} from './collection-layout-helper';

function TwoColBase({collection, stories, config, associatedMetadata}) {
  const storyCardConfig = {
    subheadline: true,
    image: true
  }
 const  {'show_collection_title': collectionName = true} = associatedMetadata;

  return (
    <div className="two-col component-wrapper">
      {collectionName ? <SectionName hideLink={true} name={collection.name} type="large" section={collectionSection(config, collection)}/> : null}
      <div className="two-col__items">
        <div className="two-col__item">
          <MediaObjectsList stories={stories.slice(0,3)} sectionColor={collectionColor(config, collection)} />
        </div>
        <div className="two-col__item full-card">
          <StoryCard story={stories[3]} config={storyCardConfig} hideSectionName={true} />
        </div>
      </div>
      
      <div className="app-ad app-ad--horizontal">
        <DfpAd adtype="Horizontal-Ad" layoutName="TwoCol" collectionSlug={collection.slug}/>
      </div>
    </div>
  )
}

export const TwoCol = wrapCollectionLayout(TwoColBase);
